module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("6")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Coronation Chair, Westminster Abbey")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Henry VIII Crowned King of England")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Coronation Chair was made under the orders of King Edward I to enclose the Stone of Scone, which had been taken from Scotland and transferred to Westminster Abbey. It was built of oak and completed in 1301. This throne was used during the coronation of thirty-eight English monarchs including the coronation ceremonies of Henry VIII and Katherine of Aragon on 24 June 1509")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("On the day before the coronation, Henry VIII, on horseback, and Katherine, in a litter, travelled in a procession from the Tower of London, through the streets of the City of London to Westminster. Edward Hall described Henry’s demeanour and appearance during that journey:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quote"
  }, [_vm._v("The feature of his body, his goodly personage, his amiable visage, princely countenance, with the noble qualities of his royal estate, to every man known, needed no rehearsal, considering, that for lack of cunning, I cannot express the gifts of grace and nature that God hath endowed him with all; yet partly, to describe his apparel, it is to be noted, his grace wore in his finest apparel, a robe of Crimson Velvet, furred with ermine, his jacket or cote of raised gold, the placard embroidered with Diamonds Rubies, Emeralds, great Pearls, and other riche Stones, a great Bauderike about his neck, of great Balasses."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch06_9",
      "id": "fnch06_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tapestries and Arras cloth were hung from the buildings along the procession route. As the royal cortège passed through Cheapside, Hall recorded that ‘every occupation stood, in their liveries in order, beginning with base and mean occupations, and so ascending to the worshipful crafts: highest and lastly stood the Mayor, with the Aldermen’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch06_10",
      "id": "fnch06_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the morning of the coronation, the royal couple walked to Westminster Palace and then towards Westminster Abbey upon cloth. After walking on this cloth, the crowd cut pieces from it as souvenirs, because, according to Hall, the ‘clothe was cut and spoiled, by the rude and common people, immediately after their repair into the Abbey’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch06_11",
      "id": "fnch06_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once in the abbey, Katherine sat on a lower chair, while Henry sat on this throne. The coronation ceremony was conducted by William Warham, Archbishop of Canterbury, in the presence of noblemen and the general public from all walks of life. When this crowd was asked whether they would receive, obey and accept this noble prince as their king, Hall recorded that ‘with great reverence, love and desire, said and cried ye, ye’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch06_12",
      "id": "fnch06_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is believed that the crowns of King Edward the Confessor and his wife, Edith, were used during the joint coronation. It was a joyous occasion, which was celebrated by a banquet in Westminster Hall and further festivities, including jousting in the days that followed. After years of political uncertainty and economic austerity during the reign of Henry VII, the accession of the youthful Henry VIII brought hope and optimism across the nation. Thomas More applauded the coronation in a letter a poem entitled ‘Coronation Ode of King Henry VIII’, proclaiming that ‘this day is the limit of our slavery, the beginning of our freedom, the end of sadness, the source of joy, for this day consecrates a young man who is the everlasting glory of our time and makes him your king’.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Coronation Chair, Westminster Abbey, on which King Henry VIII sat as he was crowned on 24 June 1509. (Copyright Dean and Chapter of Westminster)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A sixteenth-century woodcut of the coronation of Henry VIII and Katherine of Aragon showing their heraldic badges, the Tudor rose and the pomegranate of Granada. (Author’s Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine of Aragon and Anne Boleyn were the only wives of Henry VIII to be crowned at Westminster Abbey. Jane Seymour was not crowned as queen due to the plague, which was rife in London during 1536, and maybe because Henry was reluctant until she bore him a son. Henry’s marriage to Anne of Cleves was annulled before her coronation and so she was never crowned. There were no coronations for Henry’s fifth and sixth wives, Katherine Howard and Catherine Parr.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09753975","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/012_Chapter006.vue
// module id = 93
// module chunks = 0